export default "__VITE_ASSET__BxNmnc2w__"